module.exports = __webpack_public_path__ + "static/media/our_services.015f2eb6.png";